/* eslint-disable filenames/match-exported */
const hasRequiredHighlightInfo = (feedback: any) => {
  const hasLineStart = 'line_start' in feedback;
  return hasLineStart && parseInt(feedback.line_start, 10) > 0;
};

export default function getHighlightLocation(feedback: any) {
  const shouldHighlight =
    feedback != null && !feedback.correct && hasRequiredHighlightInfo(feedback);
  if (shouldHighlight) {
    const lineStart = parseInt(feedback.line_start, 10);
    const columnStart = parseInt(feedback.column_start, 10) || undefined;
    return {
      lineStart,
      lineEnd: parseInt(feedback.line_end, 10) || lineStart,
      columnStart,
      columnEnd: parseInt(feedback.column_end, 10) + 1 || columnStart,
    };
  }
  return undefined;
}
